/**
 * @generated SignedSource<<14a1967f06ee7b9ca38ccd8a4d3070bb>>
 * @relayHash a7ef2167691d228a74658bb0f648d1de
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 50b432f16f95d7a20932fae7007eb41a57ceb15f29c42c0e11bcc45e4b722f08

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "50b432f16f95d7a20932fae7007eb41a57ceb15f29c42c0e11bcc45e4b722f08",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
